if (!customElements.get('size-picker-grid-popup')) {
  customElements.define(
    'size-picker-grid-popup',
    class SizePickerGridPopup extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
        this.movePopupToBody();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      movePopupToBody() {
        if (this.parentElement === document.body) return;

        const popupId = this.dataset.popup;
        const overlay = popupId
          ? document.querySelector(`[data-popup-overlay][data-close-popup="${popupId}"]`)
          : null;

        document.querySelectorAll('size-picker-grid-popup').forEach((el) => {
          if (el !== this && el.parentElement === document.body) el.remove();
        });
        document.querySelectorAll('.size-picker-grid-popup-overlay').forEach((el) => {
          if (el !== overlay && el.parentElement === document.body) el.remove();
        });

        document.body.appendChild(this);
        if (overlay) document.body.appendChild(overlay);
      }

      handleClick(event) {
        const button = event.target.closest('[data-quick-add]');
        if (!button || button.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        this.quickAdd(button);
      }

      async quickAdd(button) {
        if (button.classList.contains('is-loading')) return;
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.classList.add('is-loading');

        try {
          const routes = (window.theme && window.theme.routes) || {};
          const url = routes.cart_add_url || '/cart/add.js';
          const formData = new FormData();
          formData.set('id', variantId);
          formData.set('quantity', '1');
          formData.set('sections', 'cart-icon-bubble,cart-drawer');
          formData.set('sections_url', window.location.pathname);

          const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/javascript' },
            body: formData,
          });

          const result = await response.json();
          if (!response.ok) throw result;

          document.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', {
              bubbles: true,
              detail: { response: result },
            })
          );

          this.closePopup();
        } catch (error) {
          console.error('size-picker-grid-popup: failed to add to cart', error);
        } finally {
          button.classList.remove('is-loading');
        }
      }

      closePopup() {
        const closeButton = this.querySelector('[data-close-popup]');
        if (closeButton) closeButton.click();
      }
    }
  );
}
